import { SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR, SET_FLEET_ITEM_RETURN_TO_REQUESTOR } from "./FleetItemReturnToRequestorType"

const initialState = {
    fleetItemReturn: null,
    assetFleetItemReturn: null
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_FLEET_ITEM_RETURN_TO_REQUESTOR:
            return {
                ...state,
                fleetItemReturn: action.fleetItemReturn
            };
            case SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR:
            return {
                ...state,
                assetFleetItemReturn: action.assetFleetItemReturn
            };
        default:
            return state;
    }
};

export default reducer;